module.exports = "<p>\r\n  logout works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/public/login/logout/logout.component.html
// module id = ./src/app/pages/public/login/logout/logout.component.html
// module chunks = main